module.exports = __webpack_public_path__ + "static/media/webdesign-services-img49.4688a0d6.jpg";